import { render, staticRenderFns } from "./CollectionAdmin.vue?vue&type=template&id=42057b71&"
import script from "./CollectionAdmin.vue?vue&type=script&lang=js&"
export * from "./CollectionAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports